import React, { useEffect, useState } from "react";
import Loader from "./components/shared/loader/loader";
import "./App.css";
import { setMetadata } from "./utils/metadata";
import { changeLanguage } from "./utils/language-helper";
import AppContainer from "./pages/AppContainer";
import { fetchMetaData } from "./apis/b2c_api";
import { cachePartnersAndAffiliates } from "./containers/Authentication/Login/LoginView/TwoFAView/LoginWithTwoFA/login-2FA-api-handler";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material";
import { getLabel } from "./hooks/use-labels";

const setLanguage = () => {
  const params = new URLSearchParams(window.location.search);
  const languageCode = params.get("language_code") || "en";
  changeLanguage(languageCode);
};

const THEME = createTheme({
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
});

const App = (): JSX.Element => {
  const [loading, setLoading] = useState(true);
  const [callMetaData, setCallMetaData] = useState(false);
  const dispatch = useDispatch();
  const { activeUser, initialCalls } = useSelector((state: RootStateOrAny) => state.users);

  useEffect(() => {
    document.title = getLabel("brandName");
  }, []);

  useEffect(() => {
    setCallMetaData(initialCalls?.haveAPIsCalled);
  }, [initialCalls]);

  useEffect(() => {
    setLanguage();

    if (!callMetaData) {
      fetchMetaData()
        .then((metadata) => {
          setMetadata(metadata?.metadata ? metadata.metadata : {});
          if (activeUser.access_token) {
            cachePartnersAndAffiliates(() => {}, dispatch).then(() => setLoading(false));
          } else {
            setLoading(false);
          }
        })
        .catch(console.error);
    }
  }, [activeUser, dispatch]);

  if (loading) return <Loader />;

  return (
    <ThemeProvider theme={THEME}>
      <div className="App">
        <AppContainer />
      </div>
    </ThemeProvider>
  );
};

export default App;
